var map = {
	"./Physio.svg": 485,
	"./PlasticSurgery.svg": 486,
	"./Podiatry.svg": 487,
	"./SleepClinic.svg": 488,
	"./Surgeon.svg": 489,
	"./audiology.svg": 490,
	"./chiropractic.svg": 491,
	"./dental.svg": 492,
	"./dermatology.svg": 493,
	"./fertility.svg": 494,
	"./naturopathy.svg": 495,
	"./psychiatry.svg": 496,
	"./vision.svg": 497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;